import React from "react"

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer text-center font-size-12 align-center">
      <span className="copyright-year">{currentYear} &copy; DomApp.</span>
    </footer>
  )
}

export default Footer
